<template>
	<div v-title title="收货地址" class="addr-page">
		<div class="manage" @click="onClickRight" v-if="dataList && dataList.length">
			{{ showDelete ? '完成' : '管理' }}
		</div>
		<div class="no-more" v-if="!dataList || !dataList.length">
			<img class="img" src="@/assets/images/coupon/bg_no_more.png" alt="" />
			<span class="tips">抱歉，暂无收货地址呢～</span>
		</div>
		<div class="addr-list" v-else>
			<div class="addr-list-item" v-for="item in dataList" :key="item.id">
				<div class="name-tel">
					<span class="name">{{ item.name }}</span>
					<span class="tel">{{ item.tel }}</span>
					<span class="tag-b" v-if="item.isDefault == '1'">默认</span>
					<span class="tag" v-if="item.tag == '0'">家</span>
					<span class="tag" v-else-if="item.tag == '1'">学校</span>
					<span class="tag" v-else-if="item.tag == '2'">公司</span>
				</div>
				<img class="icon-addr" src="@/assets/images/product/icon_addr.png" />
				<div class="addr-d">{{ item.address }}</div>
				<img class="icon-edit" v-if="showDelete" src="@/assets/images/product/icon_del.png"
					@click.stop="deleteAddress(item)" />
				<img class="icon-edit" v-else src="@/assets/images/product/icon_edit.png" @click.stop="editAddress(item)" />
			</div>
		</div>
		<div class="btn-box" @click="addAddress">
			<div class="btn">
				新增地址
			</div>
		</div>
		<MyDialog :dialogForm="dialogForm" />
	</div>
</template>

<script>
import { post } from 'api/post'
import { get } from 'api/get'
import TabBar from '@/components/tabBar/index'
import MyDialog from '@/components/MyDialog.vue'

export default {
	name: 'User',
	components: {
		TabBar, MyDialog
	},
	data() {
		return {
			dialogForm: {
				show: false,
				title: '',
				contentText: '',
				contentTips: '',
				// btnCancelText: '取 消',
				btnConfirmText: '',
				cancelCallback: () => {
					this.dialogForm.show = false
				},
				confirmCallback: () => {
					this.dialogForm.show = false
				}
			},
			showDelete: false,
			dataList: [{
				id: '',
				name: '',
				tel: '',
				address: '',
				isDefault: 0,
			}],
		};
	},
	created() {
		this.dataList = []
		this.loadAddress()
	},
	methods: {
		loadAddress() {
			let self = this
			get('member/receiveAddress/list').then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					let resData = JSON.parse(JSON.stringify(res.data))
					resData.forEach(item => {
						let newItem = {
							id: '',
							name: '',
							tel: '',
							address: '',
							isDefault: 0,
							tag: ''
						}

						let address = ''
						if (item.province && item.province != '') {
							address += item.province
						}

						if (item.city && item.city != '') {
							address += item.city
						}

						if (item.region && item.region != '') {
							address += item.region
						}

						if (item.street && item.street != '') {
							address += item.street
						}

						if (item.detailAddress && item.detailAddress != '') {
							address += item.detailAddress
						}

						newItem.id = item.id
						newItem.name = item.name
						newItem.tel = self.formatTel(item.phoneNumber)
						newItem.address = address
						newItem.tag = item.tag
						newItem.isDefault = item.isDefault

						self.dataList.push(newItem)
					})
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#ee0a24'
					})
				}
			})
		},
		formatTel(tel) {
			if (!tel) {
				return '';
			}
			return tel.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
		},
		addAddress() {
			this.$router.push("/addressDetail");
		},
		editAddress(item) {
			// Toast('编辑地址:' + index);
			this.$router.push({ path: '/addressDetail', query: { id: item.id } })
		},
		deleteAddress(item) {
			let self = this
			self.dialogForm = {
				show: true,
				title: '提示',
				contentText: '确定删除该地址吗？',
				btnCancelText: '暂不删除',
				btnConfirmText: '确定',
				cancelCallback: () => {
					this.dialogForm.show = false
				},
				confirmCallback: () => {
					this.dialogForm.show = false
					post('member/receiveAddress/delete/' + item.id).then((res) => {
						console.log(res)
						if (res.code === self.GLOBAL.SUCCESS) {
							self.$toast('刪除成功');
							this.dataList = []
							this.loadAddress()
						} else {
							self.$dialog.alert({
								theme: 'round-button',
								message: res.message,
								confirmButtonColor: '#ee0a24'
							})
						}
					})
				}
			}
		},
		onClickLeft() {
			this.$router.push("/user");
		},
		onClickRight() {
			if (this.showDelete) {
				this.showDelete = false
			} else {
				this.showDelete = true
			}
		}
	}
};
</script>

<style></style>

<style scoped lang="less">
.addr-page {
	box-sizing: border-box;
	background: #F7F7F7;
	min-height: 100vh;
	padding: 30px 0 50px;

	.manage {
		box-sizing: border-box;
		position: fixed;
		top: 0;
		left: 0;
		width: 375px;
		height: 30px;
		background: #FFFFFF;
		padding: 0 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 13px;
		color: #00754A;
		line-height: 30px;
		text-align: right;
		z-index: 1;
	}

	.no-more {
		margin: 140px auto 0;
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;

		.img {
			width: 110px;
			height: 100px;
		}

		.tips {
			margin-top: 8px;
			height: 14px;
			font-size: 12px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			color: #999999;
			line-height: 14px;
		}
	}

	.addr-list {
		padding-bottom: 30px;
		overflow: auto;

		.addr-list-item {
			box-sizing: border-box;
			margin: 10px auto;

			width: 355px;
			height: 60px;
			background: #FFFFFF;
			border-radius: 10px;
			border-radius: 10px;
			position: relative;

			.name-tel {
				height: 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 13px;
				color: #333333;
				line-height: 16px;
				position: absolute;
				top: 12px;
				left: 12px;

				.tel {
					margin-left: 10px;
					font-weight: 400;
				}

				.tag-b {
					margin: 0 6px 0 10px;
					padding: 0 4px;
					height: 16px;
					background: #00754A;
					border-radius: 4px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 11px;
					color: #FFFFFF;
					line-height: 16px;
				}

				.tag {
					padding: 0 4px;
					height: 16px;
					background: rgba(0, 117, 74, 0.06);
					border-radius: 4px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 11px;
					color: #00754A;
					line-height: 16px;
				}
			}

			.icon-addr {
				width: 14px;
				height: 14px;
				position: absolute;
				top: 34px;
				left: 12px;
			}

			.addr-d {
				position: absolute;
				top: 34px;
				left: 30px;
				width: 280px;
				height: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 11px;
				color: #666666;
				line-height: 14px;
				text-align: left;
				font-style: normal;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}

			.icon-edit {
				width: 16px;
				height: 16px;
				position: absolute;
				top: 22px;
				right: 14px;
			}

		}

	}

	.btn-box {
		position: fixed;
		left: 0;
		bottom: 0;
		width: 375px;
		height: 49px;
		background: #FFFFFF;
		padding: 5px 0 0;

		.btn {
			margin: 0 auto;
			width: 355px;
			height: 40px;
			background: #00754A;
			border-radius: 10px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 15px;
			color: #FFFFFF;
			line-height: 40px;
			text-align: center;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/view/address/list.vue